import * as Yup from "yup";

export const dataModel = {
  code: "",
  active: false,
  providerUuid: "",
  datePlanting: "",
};

export const validationDataModel = (edit) => {
  if (edit) {
    return Yup.object().shape({
      code: Yup.string().required("forms.validations.required"),
      active: Yup.boolean().required("forms.validations.required"),
      providerUuid: Yup.string().required("forms.validations.required"),
      datePlanting: Yup.string().required("forms.validations.required"),
    });
  }

  return Yup.object().shape({
    code: Yup.string().required("forms.validations.required"),
    active: Yup.boolean().required("forms.validations.required"),
    providerUuid: Yup.string().required("forms.validations.required"),
    datePlanting: Yup.string().required("forms.validations.required"),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
